const initSendHintDrawer = (drawer) => {
  if (!drawer || drawer.dataset.sendHintReady === 'true') return;

  const messageField = drawer.querySelector('[data-send-hint-message]');
  const status = drawer.querySelector('[data-send-hint-status]');
  const fallback = drawer.querySelector('[data-send-hint-fallback]');
  const copyButton = drawer.querySelector('[data-send-hint-copy]');
  const instagramButton = drawer.querySelector('[data-send-hint-instagram]');

  if (!messageField) return;

  const message = [drawer.dataset.messagePrefix || '', drawer.dataset.productTitle || '', drawer.dataset.productUrl || window.location.href]
    .filter(Boolean)
    .join(' ')
    .trim();

  const updateStatus = (state) => {
    if (!status) return;

    const messages = {
      'copy-success': status.dataset.copySuccess,
      'copy-error': status.dataset.copyError,
    };

    status.textContent = messages[state] || '';
  };

  const showFallback = () => {
    fallback?.classList.remove('hidden');
    updateStatus('copy-error');
    messageField.focus();
    messageField.select();
  };

  const hideFallback = () => {
    fallback?.classList.add('hidden');
  };

  const copyMessage = async () => {
    if (!navigator.clipboard?.writeText) {
      showFallback();
      return false;
    }

    try {
      await navigator.clipboard.writeText(message);
      hideFallback();
      updateStatus('copy-success');
      return true;
    } catch (error) {
      showFallback();
      return false;
    }
  };

  const encodedMessage = encodeURIComponent(message);
  const encodedSubject = encodeURIComponent(drawer.dataset.emailSubject || drawer.dataset.productTitle || message);
  const linkMap = {
    sms: `sms:&body=${encodedMessage}`,
    whatsapp: `https://wa.me/?text=${encodedMessage}`,
    email: `mailto:?subject=${encodedSubject}&body=${encodedMessage}`,
  };

  messageField.value = message;
  Object.entries(linkMap).forEach(([channel, href]) => {
    const link = drawer.querySelector(`[data-send-hint-link="${channel}"]`);
    if (link) link.href = href;
  });

  copyButton?.addEventListener('click', async () => {
    await copyMessage();
  });

  instagramButton?.addEventListener('click', async () => {
    const instagramUrl = drawer.dataset.instagramUrl || 'https://www.instagram.com/';
    const instagramWindow = window.open('', '_blank', 'noopener');

    await copyMessage();

    if (instagramWindow) {
      instagramWindow.location = instagramUrl;
      return;
    }

    window.open(instagramUrl, '_blank', 'noopener');
  });

  drawer.dataset.sendHintReady = 'true';
};

const initSendHintDrawers = (root = document) => {
  root.querySelectorAll('[data-send-hint]').forEach((drawer) => {
    initSendHintDrawer(drawer);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initSendHintDrawers();
});

document.addEventListener('shopify:section:load', (event) => {
  initSendHintDrawers(event.target);
});
